import { render } from "./AddCategories.vue?vue&type=template&id=167f1d10&scoped=true"
import script from "./AddCategories.vue?vue&type=script&lang=js"
export * from "./AddCategories.vue?vue&type=script&lang=js"

import "./AddCategories.vue?vue&type=style&index=0&id=167f1d10&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-167f1d10"

export default script